<template>
  <div class="replace-report-modal">
    <el-dialog
      @close="closeDialog"
      :title="step === 1 ? 'Найти в отчетах' : 'Заменить в отчетах'"
      :visible.sync="openDialog"
      width="30%"
      center
    >
      <div v-if="step === 1">
        <date-picker
          placeholder="Фильтр по дате"
          :editable="true"
          :clearable="true"
          ref="datePicker"
          v-model="dateRange"
          range
        ></date-picker>
        <el-checkbox v-model="customOnly" style="margin-top: 10px">Только произвольные работы</el-checkbox>

        <el-form class="replace-report">
          <el-form-item label="Email пользователя">
            <el-input v-model="searchFields.searchEmail" placeholder=""/>
          </el-form-item>
          <el-form-item label="Исполнитель">
            <el-input v-model="searchFields.searchCompany" placeholder=""/>
          </el-form-item>
          <el-form-item label="Объект">
            <el-input v-model="searchFields.searchObject" placeholder=""/>
          </el-form-item>
          <el-form-item label="Работа">
            <el-input v-model="searchFields.searchJob" placeholder=""/>
          </el-form-item>
          <el-form-item label="Ед. измерения">
            <el-input v-model="searchFields.searchUnit" placeholder=""/>
          </el-form-item>
        </el-form>
      </div>

      <div v-else>
        <el-form class="replace-report">
          <filter-select
            only-value
            v-model="replacementFields.replacementReporterUid"
            label="Пользователь"
            :options="options.users"
          />

          <filter-select
            only-value
            v-model="replacementFields.replacementUserId"
            label="Компания"
            :options="options.companies"
          />

          <filter-select
            only-value
            v-model="replacementFields.replacementObjectId"
            label="Объект"
            :options="options.objects"
          />

          <filter-select
            only-value
            v-model="replacementFields.replacementJobId"
            label="Работа"
            :options="jobsByObjects"
          />

          <filter-select
            only-value
            v-model="replacementFields.replacementReporterUid"
            label="Ед. измерения"
            :options="options.units"
          />


        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">Отмена</el-button>

        <el-button type="primary" @click="next">{{ step === 1 ? 'Далее' : 'Сохранить' }}</el-button>
      </div>

    </el-dialog>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import FilterSelect from "../../../../components/FilterSelect";
import {getUnits} from "../../../../firestore/units";
import firebase from "firebase";
import _ from "lodash";
import {getCompaniesOptions, getUsersOptions} from "../../../../firestore/users";
import {getObjectOptions} from "../../../../firestore/objects";
import dayjs from "dayjs";

export default {
  name: "ReplaceReport",
  components: {FilterSelect, DatePicker},
  data() {
    return {
      options: {
        users: [],
        jobs: [],
        objects: [],
        companies: [],
        units: []
      },
      openDialog: false,
      dateRange: [],
      customOnly: false,
      searchFields: {
        searchObject: "",
        searchJob: "",
        searchUnit: "",
        searchEmail: "",
        searchCompany: ""
      },
      replacementFields: {
        replacementObjectId: "",
        replacementJobId: "",
        replacementUserId: "",
        replacementCompanyId: "",
        replacementReporterUid: ""
      },
      step: 1,
    }
  },
  async mounted() {
    const users = await getUsersOptions(this.$store.state.project.id, true);

    this.options = {
      users: [{value: null, label: 'Не выбрано'}, ...users.filter((d) => d._data && !d._data.isCompany)],
      jobs: [],
      objects: await getObjectOptions(this.$store.state.project.id, null, {}, undefined, 'Не выбрано'),
      companies: [{value: null, label: 'Не выбрано'}, ...users.filter((d) => d._data && d._data.isCompany)],
      units: [{value: null, label: 'Не выбрано'}, ...(await getUnits(this.$store.state.project.id))]
    }

    this.fetchJobs()
  },
  computed: {
    jobsByObjects() {
      if (!this.replacementFields.replacementObjectId) {
        return this.options.jobs
      }

      return this.options.jobs.filter((job) => {
        return !job._data || job._data.objects.includes(this.replacementFields.replacementObjectId)
      })
    },
  },
  methods: {
    fetchJobs() {
      const result = [];
      let req = null;
      req = myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('jobs')
        .where('type', '==', 'JOB');
      req.get()
        .then((data) => {
          data.forEach((subDoc) => {
            const data = subDoc.data();
            result.push({
              value: subDoc.id,
              label: data.name,
              _data: data,
            });
          });
        })
        .finally(() => {
          this.options.jobs = [{value: null, label: 'Не выбрано'}, ..._.orderBy(result, '_data.index', ['asc'])];
        });
    },
    open() {
      this.openDialog = true
    },
    closeDialog() {
      this.openDialog = false;
      this.step = 1;
    },
    next() {
      if (this.step === 1) {
        return this.step = 2;
      }

      const proxy = firebase.functions().httpsCallable('replacePositionsInReports');
      proxy(
        {
          "projectId": this.$store.state.project.id,
          "uid": authFirestore.currentUser.uid,
          "fromDate": this.dateRange[0] ? dayjs(this.dateRange[0]).format('YYYY-MM-DD') : null,
          "toDate": this.dateRange[1] ? dayjs(this.dateRange[1]).format('YYYY-MM-DD') : null,
          "planId": (this.$store.state.project.plan && this.$store.state.project.plan.id) || null,
          "customOnly": this.customOnly,
          "searchFields": this.searchFields,
          "replacementFields": this.replacementFields,
          "save": true
        },
      ).then((response) => {
        console.log(response, 'response')
        this.$notify({
          title: response.message,
          type: 'success',
        });
      }).catch((error, r) => {
        console.log(error, r, 'error')
        this.$notify({
          title: 'Произошла ошибка',
          message: error,
          type: 'error',
        });
      }).finally(() => {
        this.loader = false;
      });

    }
  }
}
</script>

<style lang="scss">
.replace-report {
  .el-form-item {
    margin-bottom: 4px;
  }

}

.replace-report-modal {
  .dialog-footer {
    display: flex;
    justify-content: space-between;
    width: 100%;
    flex: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Projects/components/ReplaceReport.vue